import serverCheck from "../../modules/serverCheck";
import BaseService from "../BaseService";

class AccountApprovalService extends BaseService {
  /** @protected */
  baseUrl = `${serverCheck.getServer().serverTmsCustomer}/account-approval`;

  /**
   * Approve one or more pending accounts, activating them.
   * @param {number[]} accountAreaIds
   */
  approve(accountAreaIds) {
    return this.httpClient.post("/approve", { accountAreaIds });
  }

  /**
   * Reject a pending account with a reason, moving it to on hold.
   * @param {number} accountAreaId
   * @param {{ reasonCode: string, reasonCodeNotesValue?: string }} reason
   */
  reject(accountAreaId, reason) {
    return this.httpClient.post(`/${accountAreaId}/reject`, reason);
  }

  /**
   * Outstanding billing changes awaiting approval for an account area.
   * @param {number} accountAreaId
   */
  getPendingChanges(accountAreaId) {
    return this.httpClient.get(`/${accountAreaId}/pending-changes`);
  }

  /**
   * Approve (apply) all pending billing changes for an account area.
   * @param {number} accountAreaId
   */
  approveChanges(accountAreaId) {
    return this.httpClient.post(`/${accountAreaId}/pending-changes/approve`);
  }

  /**
   * Reject (discard) all pending billing changes for an account area.
   * @param {number} accountAreaId
   */
  rejectChanges(accountAreaId) {
    return this.httpClient.post(`/${accountAreaId}/pending-changes/reject`);
  }
}

const accountApprovalService = new AccountApprovalService();

export default accountApprovalService;
